// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'

export const LabelField = styled.h2``

export const LabelWrapper = styled.div<{ $editable: boolean }>`
  position: relative;

  ${({ $editable }) =>
    !$editable &&
    css`
      .Wysiwyg-editorClassName {
        padding: 0 !important;
        cursor: default;
      }

      .Wysiwyg-toolbarClassName {
        display: none;
      }
    `};

  .Wysiwyg-editorClassName {
    padding: 0 14px 14px;
  }

  .Wysiwyg-wrapperClassName {
    display: flex;
    flex-direction: column-reverse;
    cursor: text;
    border: ${({ $editable }) => ($editable ? `1px solid ${colors.gray240}` : 'none')} !important;
    background: ${colors.white100};
    margin: 0;
    border-radius: 4px;
  }

  .Wysiwyg-toolbarClassName {
    margin: 0;
    background: ${colors.gray190};
  }

  .Wysiwyg-fontFamilyClassName,
  .Wysiwyg-fontSizeClassName,
  .Wysiwyg-blockTypeClassName {
    position: relative;
  }
`

export const DragHandle = styled.div`
  width: 100%;
  height: 6px;
  position: absolute;
  z-index: 1;
`
